import { ofType } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { liveOriginalFormActions } from 'state/secondaryMarket/live/form/original/liveOriginalForm.actions';
import type { EpicWithThunk } from 'state/state.common';

export function fetchLiveAfterTabContentEpic(): EpicWithThunk {
  return (
    action$,
    state$,
    {
      selectors: {
        fromSecondaryMarket: {
          live: {
            form: {
              original: {
                liveOriginalFormSelectors: { isLoaded },
              },
            },
          },
        },
        fromSecondaryPostEventsWorkspace: { getOrderId },
      },
    },
  ) => {
    return action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketPostEvents' && tabType === 'live'),
      withLatestFrom(state$),
      filter(([{ tabId }, state]) => !isLoaded(state, tabId)),
      map(([{ tabId }, state]) => {
        const orderId = getOrderId(state, tabId);
        return liveOriginalFormActions.secondaryMarketAmendFetchRequested(tabId, orderId);
      }),
    );
  };
}
